<template>
  <b-modal id="modal-filters" centered title="Filtros" title-class="font-18">
    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="Status">
          <b-form-select
            v-model="status"
            size="sm"
            :options="options"
          ></b-form-select>
        </b-form-group>
      </div>

      <div class="col-12 col-md-6">
        <b-form-group label="Método">
          <b-form-select
            v-model="method"
            size="sm"
            :options="optionsMethod"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import IdentityService from '@services/resources/IdentityService'
import IdentityDownloadService from '@services/resources/IdentityDownloadService'
var service = IdentityService.build()
var service2 = IdentityDownloadService.build()

export default {
  props: ['obj', 'id'],
  data() {
    return {
      video: '',
      loading: false,
    }
  },
  methods: {
    accept(e) {
      this.$emit('accept', e)
    },
    deny(e) {
      this.$emit('deny', e)
    },
    formatDate(e) {
      return moment(e).format('DD/MM/YYYY HH:mm')
    },
    dowloadDoc() {
      var path = this.obj.doc_back
      const ext = path.split('.').pop()
      let data = {
        path: path,
      }
      service2
        .blob2(data)
        .then((resp) => {
          const url = window.URL.createObjectURL(new Blob([resp]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `arquivo.${ext}`)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {})

      var path2 = this.obj.doc_front
      const ext2 = path2.split('.').pop()
      let data2 = {
        path: path2,
      }
      service2
        .blob2(data2)
        .then((resp) => {
          const url = window.URL.createObjectURL(new Blob([resp]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `arquivo.${ext2}`)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {})
    },
    downloadItem() {
      this.loading = true
      let data = {
        path: this.obj.video,
      }
      service2
        .blob2(data)
        .then((resp) => {
          var p = document.getElementById('preview')
          p.innerText = ''
          document.getElementById('preview').style.display = 'block'
          document.getElementById('preview').src = window.URL.createObjectURL(
            new Blob([resp], { type: 'video/mp4' })
          )
          document.getElementById('preview').src =
            document.getElementById('preview').src + '#t=1,20'
        })
        .catch((err) => {
          console.log(err)
          document.getElementById('preview').style.display = 'none'
          var p = document.getElementById('p')
          p.innerText = 'Video não Disponivel.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePose(e) {
      switch (e) {
        case 'LOOK_UP':
          return 'Olhar para Cima'
        case 'LOOK_DOWN':
          return 'Olhar para Baixo'
        case 'LOOK_RIGHT':
          return 'Olhar para Direita'
        case 'LOOK_LEFT':
          return 'Olhar para Esquerda'
        case 'SMILE':
          return 'Sorrir'
        case 'BLINK':
          return 'Piscar'
        case 'TURN_LEFT':
          return 'Vire a Esquerda'
        case 'TURN_RIGHT':
          return 'Vire a Direita'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-tab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.link {
  color: #00897b !important;
  text-decoration: none !important;
  background-color: transparent !important;
  cursor: pointer;
}

.link:hover {
  color: #006359 !important;
}

.video {
  width: 80%;
  border-radius: 3px;
}

.link {
  color: #00897b !important;
  text-decoration: none !important;
  background-color: transparent !important;
  cursor: pointer;
}

.link:hover {
  color: #006359 !important;
}

.actions {
  text-align: end;
}
</style>